import api from '@/api/user';
import store from '@/store';

export default {
  fetchSelf() {
    return new Promise((resolve, reject) => {
      api.fetchSelf({}, true)
        .then(r => { store.commit('auth/setUser', r); resolve(r); })
        .catch(() => { reject(); });
    });
  },

  impersonate(username = '_exit') {
    api.fetchSelf({ _switch_user: username }, true)
      .then((response) => { store.commit('setUser', response); })
      .catch(this.fetchSelf); // fixme
  },
};
